const routes = [
    {
        path: "/formal/grade/change/appeal/form",
        component: () => import("../pages/AppealForm.vue"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
